module.exports = __webpack_public_path__ + "img/HT01078-25.74136fb6.jpg";